import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import {saveTokenToFirestore} from'../firebaseService'

// 1. Helper to handle Mobile (Capacitor)
const initMobilePush = async () => {
  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    console.error('User denied permissions!');
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener('registration', (token) => {
    console.log('MOBILE TOKEN:', token.value);
  
  saveTokenToFirestore(token.value); 
    // TODO: Send token.value to your backend API
  });

  PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.log('Push received:', notification);
    alert(`Notification: ${notification.title}`);
  });
};

// 2. Helper to handle Electron
const initElectronPush = () => {
  // Check if the bridge we created in preload.js exists
  if (window.electronAPI) {
    window.electronAPI.onTokenReceived((event, token) => {
       console.log('ELECTRON TOKEN:', token);
        saveTokenToFirestore(token.value); 
       // TODO: Send token to your backend API
    });
    
    window.electronAPI.onNotification((event, notification) => {
       console.log('Electron Notification:', notification);
       // Show a toast or update UI
    });
  }
};

// 3. Helper to handle Standard Web
const initWebPush = () => {
   // Standard Firebase Web SDK logic would go here
   // usually via navigator.serviceWorker.register
   console.log("Initializing Web Push...");
};

export const usePushNotifications = () => {
  useEffect(() => {
    const platform = Capacitor.getPlatform(); // 'web', 'ios', 'android'

    // Detect if running in Electron (User Agent check or window check)
    const isElectron = window && window.process && window.process.type;

    if (platform === 'ios' || platform === 'android') {
      initMobilePush();
    } else if (isElectron) {
      initElectronPush();
    } else {
      initWebPush();
    }

    // Cleanup listeners if necessary (mostly for mobile)
    return () => {
      if (platform !== 'web') {
        PushNotifications.removeAllListeners();
      }
    };
  }, []);
};